import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";
import { MessageSquare, ExternalLink } from "lucide-react";

export default function Forum() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/forum").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);

  return (
    <div className="dr-grain min-h-screen bg-[#090B0E]">
      <Navbar />
      <main className="relative z-20 max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head text-3xl sm:text-4xl font-black mb-2 flex items-center gap-3"><MessageSquare className="text-[#D4AF37]" /> Fórum</h1>
        <p className="text-[#9CA3AF] mb-6">Avisos, novidades e links oficiais da administração.</p>
        {posts.length === 0 ? (
          <div className="dr-card p-10 text-center text-[#9CA3AF]" data-testid="forum-empty">Nenhuma publicação ainda. Volte em breve!</div>
        ) : (
          <div className="space-y-4" data-testid="forum-list">
            {posts.map((p) => (
              <article key={p.id} className="dr-card p-6" data-testid={`forum-post-${p.id}`}>
                <h2 className="font-head text-xl font-bold text-[#F3E5AB]">{p.title}</h2>
                <div className="text-[11px] text-[#6b7280] mb-3">{p.author} • {p.created_at ? new Date(p.created_at).toLocaleString("pt-BR") : ""}</div>
                {p.body ? <p className="text-sm text-[#C9CED6] whitespace-pre-wrap">{p.body}</p> : null}
                {p.link ? (
                  <a href={p.link} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm text-[#10B981] hover:underline">
                    <ExternalLink size={14} /> Abrir link
                  </a>
                ) : null}
              </article>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
